import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TypeDescriptionReportService {
  constructor(private http: HttpClient) {}

  GetReport(): Observable<Blob> {
    return this.http.get('/api/report/TypeDescriptionReport', { responseType: 'blob' });
  }
}
